import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/IndustryCard.css';

interface IndustryCardProps {
  id: string;
  number: string;
  icon: string;
  title: string;
  description: string;
  link?: string;
  isClickable?: boolean;
}

const IndustryCard: React.FC<IndustryCardProps> = ({
  id,
  number,
  icon,
  title,
  description,
  link,
  isClickable = true
}) => {
  const CardContent = () => (
    <div className="industry-card-idc">
      <div className="industry-card-header-idc">
        <span className="industry-card-number-idc">{number}</span>
      </div>
      
      <div className="industry-card-icon-wrapper-idc">
        <div className="industry-card-icon-idc">
          <img src={icon} alt={title} />
        </div>
      </div>
      
      <div className="industry-card-content-idc">
        <h3 className="industry-card-title-idc">{title}</h3>
        <p className="industry-card-description-idc">{description}</p>
        <div className="industry-card-learn-more-idc">
          Learn More
        </div>
      </div>
    </div>
  );

  if (isClickable && link) {
    return (
      <Link to={link} className="industry-card-link-idc">
        <CardContent />
      </Link>
    );
  }

  return <CardContent />;
};

export default IndustryCard; 